<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M2,1C2,1,2,15,2,15C2,15.55,2.45,16,3,16C3,16,4,16,4,16C4,16,4,0,4,0C4,0,3,0,3,0C2.45,0,2,0.45,2,1C2,1,2,1,2,1ZM13,0C13,0,12,0,12,0C12,0,12,7,12,7C12,7,10,5,10,5C10,5,8,7,8,7C8,7,8,0,8,0C8,0,5,0,5,0C5,0,5,16,5,16C5,16,13,16,13,16C13.55,16,14,15.55,14,15C14,15,14,1,14,1C14,0.45,13.55,0,13,0C13,0,13,0,13,0Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Book',
} as DefineComponent
</script>
